import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { FiLogOut } from "react-icons/fi";
import "../../css/Common/commonpopup.css";

export default function CommonPopUp({
    visible,
    onHide,
    onConfirm,

    title = "Confirm",
    message = "Are you sure?",
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",

    showCloseIcon = false,   
    loading = false,
}) {
    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            modal
            draggable={false}
            showHeader={false}
            closable={showCloseIcon}  
            className="confirm-dialog"
        >
            <div className="confirm-card">
                {showCloseIcon && (
                    <span className="confirm-close" onClick={onHide}>
                        ×
                    </span>
                )}

                <div className="confirm-icon">
                    <FiLogOut size={18} />
                </div>

                <h2 className="confirm-title">{title}</h2>

                <p className="confirm-text">{message}</p>

                <Button
                    label={confirmLabel}
                    className="confirm-primary"
                    onClick={onConfirm}
                    loading={loading}
                />
                <Button
                    label={cancelLabel}
                    className="confirm-cancel"
                    onClick={onHide}
                    disabled={loading}
                />

                <div className="confirm-glow" />
            </div>
        </Dialog>
    );
}
